import {useLingui} from '@lingui/react/macro';
import {Svg, Path} from 'react-native-svg';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useMenu} from 'extensions/viewport/useMenu';
import {useModalSort} from 'interface/hooks/useModalSort';
import {useModalFilter} from 'interface/hooks/useModalFilter';
import {vectors, colors} from 'config/styles';

import * as effectsFiles from 'interface/hooks/effects/files';

export function useMenuDisplay(folderKey: string) {
  const {t} = useLingui();
  const dispatch = useDispatch();
  const toggleView = useCallback(effectsFiles.layout(dispatch), []);
  const modalSort = useModalSort(folderKey);
  const modalFilter = useModalFilter(folderKey);
  const {open, exit, reference} = useMenu(
    () => [
      {
        command: 'header',
        text: t`Display Options`,
      },
      {
        command: 'sort',
        text: t`Sort Folder`,
        icon: (
          <Svg viewBox={'0 0 24 24'} width={24} height={24}>
            <Path d={vectors.icons.sortAlt} fill={colors.neutral.mid}/>
          </Svg>
        ),
      },
      {
        command: 'filter',
        text: t`Filter Items`,
        icon: (
          <Svg viewBox={'0 0 24 24'} width={24} height={24}>
            <Path d={vectors.icons.filter} fill={colors.neutral.mid}/>
          </Svg>
        ),
      },
      {
        command: 'layout',
        text: t`Toggle Layout`,
        icon: (
          <Svg viewBox={'0 0 24 24'} width={24} height={24}>
            <Path d={vectors.icons.list} fill={colors.neutral.mid}/>
          </Svg>
        ),
      },
    ],
    (command) => {
      switch (command) {
        case 'sort':
          modalSort.open();
          break;
        case 'filter':
          modalFilter.open();
          break;
        case 'layout':
          toggleView();
          break;
      }
      exit();
    }
  , false);

  return {open, exit, reference};
}
